import z from "zod";

export const TradeTickerSchema = z.object({
  pairSymbol: z.string(),
  base: z.string(),
  quote: z.string(),
  price: z.number(),
  markPrice: z.number().optional(),
  quoteVolume24h: z.number().optional(),
});

export type TradeTicker = z.infer<typeof TradeTickerSchema>;

export const MarkPriceSchema = z.object({
  symbol: z.string(),
  markPrice: z.number().optional(),
  timestamp: z.number().optional(),
  datetime: z.string().optional(),
  info: z.record(z.string(), z.unknown()),
});

export type MarkPrice = z.infer<typeof MarkPriceSchema>;

export const OpenInterestSchema = z.object({
  symbol: z.string(),
  openInterestAmount: z.string(),
  timestamp: z.number().optional(),
});

export type OpenInterest = z.infer<typeof OpenInterestSchema>;
